<template>
  <div class="wrapper wrapper-404">
    <div>
      <div class="area-404">
        <h2>404 File not found</h2>
        <p class="txt-404">
          ページが見つかりませんでした。<br>申し訳ございませんが、お探しのページ見つかりませんでした。<br>削除されたか、URLが間違っている可能性があります。
        </p>
        <Button @click="returnTop">TOPへ戻る</Button>
      </div>
    </div>

    <footer>
      <ul class="list-unstyled">
        <li><a href="#" @click.prevent="openTermsOfService">利用規約</a></li>
        <li><a href="#" @click.prevent="openPrivacyPolicy">プラバシーポリシー</a></li>
      </ul>
      <div>© Novars inc.</div>
    </footer>
  </div><!-- end .wrapper-->
</template>

<script>
import { Button } from "components";

export default {
  name: "NotFound",
  components: {
    Button,
  },
  methods: {
    returnTop() {
      this.$router.push("/");
    },
    async openPrivacyPolicy() {
      window.open("https://novars.jp/siteinfo/privacy/", "_blank");
    },
    async openTermsOfService() {
      window.open("https://mimamori.novars.jp/s/terms_of_service.html", "_blank");
    },
  },
};
</script>
